import { Dispatch, SetStateAction, useContext, useState } from "react";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import { Organization_State, Type_Of_Organization } from "@generated/graphql";
import fetchWithAuthRetry from "helpers/fetch/fetchRefreshToken";
import qs from "qs";
import { DaDataApi } from "dadata-api";

interface UseDaDataParams {
  status?: Organization_State;
  type?: Type_Of_Organization;
  branch_type?: "MAIN" | "BRANCH";
  kpp?: string;
  count?: number;
  query: string;
}

export type DaDataSuggestion = DaDataApi.Suggestion<DaDataApi.Party>;

export interface DaDataResponse {
  suggestions: DaDataSuggestion[];
}

const useDaData = () => {
  const { addToast } = useContext(ToastContext);
  const [loading, setLoading] = useState(false);

  const getDaData = async (
    params: UseDaDataParams,
    setDaDataResponse: Dispatch<SetStateAction<DaDataResponse["suggestions"] | undefined>>
  ) => {
    const query = qs.stringify(params);
    setLoading(true);
    await fetchWithAuthRetry(`${process.env.REACT_APP_API_URL}/company/dadata?${query}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Unable to fetch dadata");
        }

        return res.json();
      })
      .then((res: DaDataResponse) => {
        setDaDataResponse(res.suggestions);
      })
      .catch(() => addToast({ type: ToastTypeEnum.ERROR }))
      .finally(() => setLoading(false));
  };

  return { getDaData, loading };
};

export default useDaData;
